export const StorageKeys = {
  CORRELATION_ID: 'correlation-id',
  USER_ID: 'user_id',
  USER_COUNTRY_CODE: 'user_country_code',
  USER_CURRENCY_CODE: 'user_currency_code',
  FEATURE_FLAGS: 'FEATURE_FLAGS',
  BASKET_ADDITIONAL_DETAILS: 'BASKET_ADDITIONAL_DETAILS',
  BASKET_PAYMENT_OPTIONS: 'BASKET_PAYMENT_OPTIONS',
  BASKET_BALANCE_BOOSTER_OPTIONS: 'BASKET_BALANCE_BOOSTER_OPTIONS',
  BASKET_TRAVELER_INFORMATION: 'BASKET_TRAVELER_INFORMATION',
}

export type StorageKeysEnum = (typeof StorageKeys)[keyof typeof StorageKeys]
